import { useEffect, useState } from 'react';
import type { Channel } from 'pusher-js';
import { acquireChannel, releaseChannel } from '../channel-registry';
import type { UseChannelOptions } from '../types';
import { useRealtimeContext } from '../use-realtime-context';

export const useChannel = ({
  channelName,
  enabled = true,
  channelType = 'public',
}: UseChannelOptions): { channel: Channel | null; normalizedChannelName: string | null } => {
  const { client, isConnected } = useRealtimeContext();
  const [channel, setChannel] = useState<Channel | null>(null);
  const [normalizedChannelName, setNormalizedChannelName] = useState<string | null>(null);

  useEffect(() => {
    if (!enabled || !client || !isConnected || !channelName) {
      setChannel(null);
      setNormalizedChannelName(null);
      return undefined;
    }

    const channelRef = acquireChannel(client, channelName, channelType);
    setChannel(channelRef.channel);
    setNormalizedChannelName(channelRef.normalizedName);

    return () => {
      releaseChannel(client, channelRef.normalizedName);
      setChannel(null);
      setNormalizedChannelName(null);
    };
  }, [client, channelName, enabled, channelType, isConnected]);

  return {
    channel,
    normalizedChannelName,
  };
};
